import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import { useEffect } from "react";

import MyCalendar from "./MyCalender";


export const CalenderView = observer(() => {


    return (
      <>
        <div>
          <h3>Notifications</h3>
         <MyCalendar/>
        
        
        </div>
  
      
      </>
    );
  });
  